import { createStore, applyMiddleware } from 'redux';
import { persistStore } from 'redux-persist';
import logger from 'redux-logger';

import rootReducer from './root-reducer';

const middlewares = [logger];

// This logs state of variables on console. Use this while debugging.
// export const store = createStore(rootReducer, applyMiddleware(...middlewares));
export const store = createStore(rootReducer);

export const persistor = persistStore(store);
